<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="generatMonthly">生成统计表</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <!-- <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template> -->
    </Table>

    <Dialog class="dialog" ref="dialog" :title="title" @closed="dialogClosed" :width="'400px'">
      <template #default>
        <el-form class="searchForm" :model="modalSearchForm">
          <FormItem v-for="(c, i) in modalSearchFormCtrl" :key="'msformItem' + i" :viewMode="false" :config="c"
            :options="c.options" :inputValue="modalSearchForm[c.keyName]" @onChange="onModalSearchFormChange" />
        </el-form>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 定</el-button>
          <el-button @click="hideDialog">取 消</el-button>
        </div>
      </template>
    </Dialog>

  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  mixins: [tableMixin],
  components: { Wxts },
  data() {
    return {
      baseUrl: 'fwages',
      breadcrumb: [
        { name: "财务管理", path: `/finance/monthlyStatistical` },
        { name: "月度统计表", path: `/finance/monthlyStatistical` },
      ],
      wxtsList: [
        {
          name: '毛利额=运费总额-出车费用-固定费用-维保费用-附加费用-亏吨金额+补差金额'
        },
      ],
      formInline: { year: undefined },
      formCtrl: [
        {
          label: "年份：",
          placeholder: "请选择年份",
          keyName: "year",
          type: 'year',
        },
      ],
      cols: [
        { keyName: "month", label: "月份" },
        { keyName: "allfreight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "gomoney", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allfixed", label: "固定费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allrepair", label: "维保费用", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "drivermoney", label: "司机工资", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "escortmoney", label: "押运员工资", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprices", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "补差金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "allprofit", label: "毛利额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: ['drivermoney', 'escortmoney', "additional", "compen", "allfreight", "allrepair", "allfixed", "gomoney", "allprofit", "dtonprices"],
      baseParams: ['year'],
      title: '月度统计表生成',
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          label: "月份选择：",
          keyName: "month",
          type: "select",
          options: []
        },
      ],
      team: [],
    };
  },
  methods: {
    getList(staticfresh) {
      this.loading = true
      if (!staticfresh) {
        this.tableData = [];
      }
      let url = `monther/${this.getListUrl}`;
      const params = {
        userid: this.user.id,
        page: this.page,
        limit: this.limit,
      }
      const object = this.formInline
      // console.log({...this.formInline})
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, (res) => {
        this.loading = false
        // console.log(res.data)
        this.tableDataHandler(res);
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    generatMonthly() {
      this.showDialog()
    },
    onModalSearchFormChange({ key, value }) {
      // console.log(key, value)
      this.modalSearchForm[key] = value;
      console.log({ ...this.modalSearchForm })
    },
    onModalSubmit() {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        userid: this.user.id,
        ...this.modalSearchForm,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
          this.hideDialog()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    dialogClosed() { },
    setOptions({ month, team }) {
      this.modalSearchFormCtrl[0].options = month.map(v => {
        return {
          label: v,
          value: v,
        }
      })
      console.log(this.modalSearchFormCtrl)
      this.modalSearchForm.month = month[0]

      this.formCtrl.map(v => {
        if (v.keyName == 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
    },
  },
  mounted() {
    this.$set(this.formInline, 'year', this.DATE_OBJ.y)
    // console.log({ ...this.formInline })
    this.getList()
    this.getOptions()
  },
};
</script>
<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}

.el-dialog__body .btns {
  text-align: center;
}
</style>